import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import StyledShopBreadCrumb from './ShopBreadCrumb.styled';
import SVGIcon from '../utility/SVGIcon';
import { ThemePramsContext } from '../../App';

// Shop filter breadcrumb. Fonts and styling come from breadCrumbConfig of the
// selected market config, so every marketplace keeps its own typography.
const ShopBreadCrumb = React.memo((props) => {
  const { name, id, clearAll, count, selectType, checkFilter, checkFilterPrice, disabled, uri_param } = props;
  const { breadCrumbConfig = {} } = useContext(ThemePramsContext);
  const { className = 't-font-artifex', styling = {}, icon = 'close' } = breadCrumbConfig.shop || {};

  return (
    <StyledShopBreadCrumb
      disabled={count === 0 || disabled}
      className={className}
      themeProps={styling}
      onClick={() => {
        if (clearAll) {
          return clearAll();
        } else {
          return selectType === 'priceRange' && checkFilterPrice
            ? checkFilterPrice(id, 0, 0)
            : checkFilter(uri_param, selectType, name);
        }
      }}
    >
      {!clearAll && <SVGIcon name={icon} width="8" />}
      {clearAll && (
        <span>
          {name} {`(${count})`}
        </span>
      )}
      {!clearAll && <span>{name}</span>}
    </StyledShopBreadCrumb>
  );
});

ShopBreadCrumb.propTypes = {
  name: PropTypes.string,
  clearAll: PropTypes.func,
  disabled: PropTypes.bool,
  count: PropTypes.number,
  key: PropTypes.string,
  id: PropTypes.string,
  uri_param: PropTypes.string,
  selectType: PropTypes.string,
  checkFilter: PropTypes.func,
  checkFilterPrice: PropTypes.func,
};

export default ShopBreadCrumb;
